"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("circle", { cx: "25.8", cy: "15.393", r: "2.5" }),
  React.createElement("path", { d: "M34.875 8H5.125A1.068 1.068 0 0 0 4 9v22a1.068 1.068 0 0 0 1.125 1h29.75A1.068 1.068 0 0 0 36 31V9a1.068 1.068 0 0 0-1.125-1zM34 26c-1.791-1.058-4-2.656-5.562-2.656C25.5 23.344 24 26 21.057 26S16.939 20 14 20c-2.672 0-8 6-8 6V10h28z" }),
  React.createElement("path", { d: "M2 6h30V5a1.068 1.068 0 0 0-1.125-1H1.125A1.068 1.068 0 0 0 0 5v22a1.068 1.068 0 0 0 1.125 1H2z" })
);

